import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("オリジナル情報の編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, "選択肢", -1)
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "選択肢を追加", -1)
const _hoisted_8 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, " 複数選択 ", -1)
const _hoisted_10 = { class: "p-3 flex items-center bg-primary-100" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "share",
  class: "pl-2 cursor-pointer"
}, " 複数選択を可能にする ", -1)
const _hoisted_12 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, "共有範囲", -1)
const _hoisted_14 = { class: "p-3 flex items-center bg-primary-100" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "share",
  class: "pl-2 cursor-pointer"
}, " 管理人にも共有する ", -1)
const _hoisted_16 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, "生徒共有", -1)
const _hoisted_18 = { class: "p-3 flex items-center bg-primary-100" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  for: "student-share",
  class: "pl-2 cursor-pointer"
}, " スクールAI上で生徒画面に表示する ", -1)
const _hoisted_20 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, "生徒編集", -1)
const _hoisted_22 = { class: "p-3 flex items-center bg-primary-100" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  for: "student-edit",
  class: "pl-2 cursor-pointer"
}, " スクールAI上で生徒自身が編集できるようにする ", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" オリジナル情報を削除 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "情報タイトル",
          name: "title",
          type: "text",
          placeholder: "例) 小テスト点数",
          value: _ctx.title,
          invalid: !_ctx.validTitle,
          "invalid-message": 
            !_ctx.validTitleLength
              ? '情報タイトルは入力必須です'
              : !_ctx.isTileUnique
              ? 'すでに使用されているタイトルです'
              : ''
          ,
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.title = $event))
        }, null, 8, ["value", "invalid", "invalid-message"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "値の種類",
          name: "type",
          placeholder: "値の種類を選択",
          options: _ctx.types,
          value: _ctx.type,
          "value-key": "type",
          "text-key": "text",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.type = $event))
        }, null, 8, ["options", "value"])
      ]),
      (_ctx.type == 'select')
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.choices, (choice, i) => {
              return (_openBlock(), _createBlock("div", {
                key: i,
                class: "flex mb-4"
              }, [
                _createVNode("input", {
                  type: "text",
                  name: 'choice' + i,
                  placeholder: "選択肢を入力",
                  value: choice,
                  class: "w-full bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300",
                  onInput: ($event: any) => (_ctx.choices[i] = $event.target.value)
                }, null, 40, ["name", "value", "onInput"]),
                _createVNode(_component_m_button, {
                  color: "gray-500",
                  text: "",
                  class: "ml-3",
                  onClick: ($event: any) => (_ctx.deleteChoice(i))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_m_icon, { type: "close" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_m_button, {
                color: "gray-500",
                size: "sm",
                text: "",
                class: "ml-3",
                onClick: _ctx.addChoice
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'select')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _withDirectives(_createVNode("input", {
                id: "share",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.multiple = $event)),
                type: "checkbox",
                name: "share",
                class: "cursor-pointer"
              }, null, 512), [
                [_vModelCheckbox, _ctx.multiple]
              ]),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode("input", {
            id: "share",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.shareToAdmin = $event)),
            type: "checkbox",
            name: "share",
            class: "cursor-pointer"
          }, null, 512), [
            [_vModelCheckbox, _ctx.shareToAdmin]
          ]),
          _hoisted_15
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _withDirectives(_createVNode("input", {
            id: "student-share",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showToStudent = $event)),
            type: "checkbox",
            name: "student-share",
            class: "cursor-pointer"
          }, null, 512), [
            [_vModelCheckbox, _ctx.showToStudent]
          ]),
          _hoisted_19
        ])
      ]),
      (_ctx.showToStudent)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _withDirectives(_createVNode("input", {
                id: "student-edit",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editableByStudent = $event)),
                type: "checkbox",
                name: "student-edit",
                class: "cursor-pointer"
              }, null, 512), [
                [_vModelCheckbox, _ctx.editableByStudent]
              ]),
              _hoisted_23
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteCustomProperty
      }, {
        default: _withCtx(() => [
          _hoisted_24
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.update
      }, {
        default: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}